import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is handled entirely via an httpOnly session cookie set by the backend.
// withCredentials ensures the cookie is sent with every cross-origin request.
const api = axios.create({ baseURL: API, withCredentials: true });

export default api;
